import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';

export const useSessions = () => {
  return useQuery({
    queryKey: QUERY_KEYS.sessions,
    queryFn: () => container.sessions.list(),
  });
};

export const useRevokeSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => container.sessions.revoke(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.sessions }),
  });
};

export const useRevokeOtherSessions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => container.sessions.revokeOthers(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.sessions }),
  });
};
